import React from "react";
import { useTranslation } from "react-i18next";
import "./AdminActionModal.css";

function AdminActionModal({ isOpen, onClose, action, type }) {
  const { t, i18n } = useTranslation();
  if (!isOpen || !action) return null;

  const isBan = type === "ban";
  const title = isBan ? t("profile_page.admin_action_modal.title_ban") : t("profile_page.admin_action_modal.title_reject");
  const icon = isBan ? "🚫" : "❌";
  const accentColor = isBan ? "#ff4444" : "#ff9500";

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString(i18n.language === "pt" ? "pt-BR" : "en-US", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const formatDetails = (details) => {
    if (!details) return null;
    if (typeof details === "string") return details;
    return JSON.stringify(details, null, 2);
  };

  return (
    <div className="admin-action-modal-overlay" onClick={onClose}>
      <div className="admin-action-modal" onClick={(e) => e.stopPropagation()} style={{ "--accent-color": accentColor }}>
        {/* Header */}
        <div className="admin-action-header">
          <div className="admin-action-icon">{icon}</div>
          <h2 className="admin-action-title">{title}</h2>
          <button className="admin-action-close" onClick={onClose}>
            ×
          </button>
        </div>

        {/* Content */}
        <div className="admin-action-content">
          {/* Bot Info */}
          <div className="admin-action-section">
            <h3 className="section-title">{t("profile_page.admin_action_modal.bot_info")}</h3>
            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">{t("profile_page.admin_action_modal.name")}</span>
                <span className="info-value">{action.botName}</span>
              </div>
              <div className="info-item">
                <span className="info-label">{t("profile_page.admin_action_modal.id")}</span>
                <span className="info-value bot-id">{action.botId}</span>
              </div>
            </div>
          </div>

          {/* Admin Info */}
          <div className="admin-action-section">
            <h3 className="section-title">{t("profile_page.admin_action_modal.admin_responsible")}</h3>
            <div className="admin-info">
              <img src={action.adminAvatar} alt={action.adminUsername} className="admin-avatar" />
              <div className="admin-details">
                <span className="admin-name">{action.adminUsername}</span>
                <span className="admin-id">ID: {action.adminId}</span>
              </div>
            </div>
          </div>

          {/* Reason */}
          <div className="admin-action-section">
            <h3 className="section-title">{t("profile_page.admin_action_modal.reason")}</h3>
            <div className="reason-box">{action.reason || t("profile_page.admin_action_modal.no_reason")}</div>
          </div>

          {/* Details (if exists) */}
          {action.details && (
            <div className="admin-action-section">
              <h3 className="section-title">{t("profile_page.admin_action_modal.additional_details")}</h3>
              <div className="details-box">
                <pre>{formatDetails(action.details)}</pre>
              </div>
            </div>
          )}

          {/* Date */}
          <div className="admin-action-section">
            <h3 className="section-title">{t("profile_page.admin_action_modal.date_time")}</h3>
            <div className="date-box">{formatDate(action.createdAt)}</div>
          </div>

          {/* Tip for rejected bots */}
          {!isBan && (
            <div className="admin-action-tip">
              <div className="tip-icon">💡</div>
              <div className="tip-content">
                <strong>{t("profile_page.admin_action_modal.tip_title")}</strong> {t("profile_page.admin_action_modal.tip_content")}
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="admin-action-footer">
          <button className="btn-close-modal" onClick={onClose}>
            {t("profile_page.admin_action_modal.btn_understand")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminActionModal;
